module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-1.10455010.png";